import React from "react";
import EmailViewerPro from "./Unibox/EmailViewerPro";
import EmailGeneral from "./Unibox/whatsappEmail/EmailGeneral";
import { GlobalStyles } from "@mui/material";

function App() {
  return (
    <>
      <GlobalStyles
        styles={{
          ".ProseMirror-selectednode": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          ".ProseMirror-node-selected": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          ".ProseMirror .selectedNode": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          ".ProseMirror *[style*='outline']": {
            outline: "none !important",
          },
          ".ProseMirror *[style*='border']": {
            border: "none !important",
          },
          ".ProseMirror *[style*='box-shadow']": {
            boxShadow: "none !important",
          },

          // 🔥 IMPORTANTE: quita el borde del editor entero
          ".ProseMirror": {
            outline: "none !important",
            border: "none !important",
            minHeight: "200px",
            padding: "10px",
          },
          ".ProseMirror:focus": {
            outline: "none !important",
            border: "none !important",
          },
          ".ProseMirror:focus-visible": {
            outline: "none !important",
          },
          /* ".ProseMirror p": {
            marginTop: "4px !important",
            marginBottom: "4px !important",
          }, */
          // opcional para aún menos espacio
          ".ProseMirror p + p": {
            marginTop: "2px !important",
            marginBottom: "2px !important",
          },

          ".ProseMirror p": {
            margin: "0 0 8px",
          },
        }}
      />

      <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
        {/*  <EmailViewerPro /> */}
        <EmailGeneral />
      </div>
    </>
  );
}

export default App;
